export const ETSY_WHO_MADE_OPTIONS = [
  { value: 'i_did', label: 'I did' },
  { value: 'collective', label: 'Collective' },
  { value: 'someone_else', label: 'Someone else' }
];

export const ETSY_WHEN_MADE_OPTIONS = [
  { value: 'made_to_order', label: 'Made to order' },
  { value: '2020_2026', label: '2020_2026' },
  { value: '2010_2019', label: '2010-2019' },
  { value: '2005_2009', label: '2005-2009' },
  { value: '2000_2004', label: '2000-2004' },
  { value: '1990s', label: '1990s' },
  { value: '1980s', label: '1980s' },
  { value: '1970s', label: '1970s' },
  { value: '1960s', label: '1960s' },
  { value: '1950s', label: '1950s' },
  { value: '1940s', label: '1940s' },
  { value: '1930s', label: '1930s' },
  { value: '1920s', label: '1920s' },
  { value: '1910s', label: '1910s' },
  { value: '1900s', label: '1900s' },
  { value: '1800s', label: '1800s' },
  { value: '1700s', label: '1700s' },
  { value: 'before_1700', label: 'Before 1700' }
];

export const ETSY_READINESS_STATE_OPTIONS = [
  { value: 'ready_to_ship', label: 'Ready to ship' },
  { value: 'made_to_order', label: 'Made to order' }
];

export const ETSY_PROCESSING_TIME_UNIT_OPTIONS = [
  { value: 'days', label: 'Days' }
];

export const ETSY_DESTINATION_REGION_OPTIONS = [
  { value: 'none', label: 'None' },
  { value: 'eu', label: 'EU' },
  { value: 'non_eu', label: 'Non-EU' }
];

export function normalizeEtsyWhoMade(value) {
  if (value === 'i did') {
    return 'i_did';
  }
  if (value === 'someone else') {
    return 'someone_else';
  }
  return value || 'i_did';
}

export function normalizeEtsyWhenMade(value) {
  return value || 'made_to_order';
}
